export { exhaustSwitchCase };
// The unhandled value's DISCRIMINANT only — never the whole value.
//
// Our domain objects (events, commands, errors) carry their payload under a
// `type` discriminant. The old `JSON.stringify(x)` embedded that entire
// payload into the thrown message, so an unhandled event variant leaked its
// content into error text — and from there into logs and any diagnostics
// bundle assembled from them (error-reporting.md §4: `Error.message` is the
// sneaky leak). Surfacing just the discriminant keeps the highest-value crash
// signal (which case was missed) without carrying content off the machine.
//
// `x` is typed `never` — the compiler proves the switch is exhaustive — but at
// runtime it is whatever slipped through. We read `type` through `in`-operator
// narrowing (no cast), falling back to the primitive's `typeof` when there is
// no string discriminant to name.
const discriminantOf = (x) => {
    if (typeof x === "object" && x !== null && "type" in x) {
        const type = x.type;
        if (typeof type === "string")
            return type;
    }
    return typeof x;
};
const exhaustSwitchCase = (x) => {
    throw new Error(`unhandled case: ${discriminantOf(x)}`);
};
//# sourceMappingURL=exhaust.js.map